import {Badge, Button, Form, Image, Input, InputNumber, message, Modal, Select, Tag} from "antd";
import {useFormik} from "formik";
import React, {useState} from "react";
import {useStore} from "../../../../hooks/useStore";
import {Link} from "react-router-dom";
import moment from "moment";
import {
    creditLogObjectionApprovalTypesForCompany,
    creditLogObjectionApprovalTypesForCourier,
    creditLogsObjectionTypes
} from "../../../../constants/constants";
import * as Yup from "yup";
import {useTranslation} from "react-i18next";
export const ChangeObjectionStatusModal = ({
    visibility,
    onCancel,
    objectionId,
    objection,
    refetch
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [status, setStatus] = useState("");
    const [fileModalVisible, setFileModalVisible] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const handlePreviewFiles = files => {
        setSelectedFiles(files);
        setFileModalVisible(true);
    };

    const initialValues = {
        status,
        approvedCompanyPaybackAmount: objection?.requestedAmount || 0,
        approvedCourierDedictionAmount: 0,
        objectionId: objection?._id || "",
        note: "",

        //custom inputs for validation
        companyProcessType:
            objection?.type === "missingPayment"
                ? "deductFromCompanyCredit"
                : objection?.type === "overPayment"
                ? "addToCompanyCredit"
                : "none",
        courierProcessType: "none"
    };

    const generateCompanyProcessType = processType => {
        switch (processType) {
            case "deductFromCompanyCredit":
                return {
                    isCompanyProcessActive: true,
                    isDeductFromCompanyCredit: true,
                    isAddToCompanyCredit: false
                };
            case "addToCompanyCredit":
                return {
                    isCompanyProcessActive: true,
                    isAddToCompanyCredit: true,
                    isDeductFromCompanyCredit: false
                };
            case "none":
                return {
                    isCompanyProcessActive: false,
                    isAddToCompanyCredit: false,
                    isDeductFromCompanyCredit: false
                };
        }
    };
    const generateCourierProcessType = processType => {
        switch (processType) {
            case "deductFromCourierEarnings":
                return {
                    isCourierProcessActive: true,
                    isDeductFromCourierEarnings: true,
                    isAddToCourierEarnings: false
                };
            case "addToCourierEarnings":
                return {
                    isCourierProcessActive: true,
                    isAddToCourierEarnings: true,
                    isDeductFromCourierEarnings: false
                };
            case "none":
                return {
                    isCourierProcessActive: false,
                    isAddToCourierEarnings: false,
                    isDeductFromCourierEarnings: false
                };
        }
    };

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async values => {
            const decisionData = {
                isCompanyProcessActive: false,
                isCourierProcessActive: false,
                isDeductFromCourierEarnings: false,
                isAddToCourierEarnings: false,
                isDeductFromCompanyCredit: false,
                isAddToCompanyCredit: false,
                ...generateCompanyProcessType(values.companyProcessType),
                ...generateCourierProcessType(values.courierProcessType)
            };
            if (values?.status === "approved") {
                if (
                    !decisionData?.isCompanyProcessActive &&
                    !decisionData?.isCourierProcessActive
                ) {
                    message.error("Onaylanacak bir işlem seçiniz.");
                    return;
                }

                if (
                    !values?.approvedCompanyPaybackAmount &&
                    !values?.approvedCourierDedictionAmount
                ) {
                    message.error("Onaylanacak bir miktar giriniz.");
                    return;
                }

                if (
                    decisionData?.isDeductFromCourierEarnings &&
                    decisionData?.isAddToCourierEarnings
                ) {
                    message.error("Kurye hakedişi hem eklenecek hem düşülecek olamaz.");
                    return;
                }

                if (decisionData?.isDeductFromCompanyCredit && decisionData?.isAddToCompanyCredit) {
                    message.error("Firma kredisi hem eklenecek hem düşülecek olamaz.");
                    return;
                }

                if (
                    decisionData?.isCompanyProcessActive &&
                    (!values?.approvedCompanyPaybackAmount ||
                        values?.approvedCompanyPaybackAmount < 0)
                ) {
                    message.error("Firma kredisi için onaylanacak miktar gereklidir.");
                    return;
                }

                if (
                    decisionData?.isCourierProcessActive &&
                    (!values?.approvedCourierDedictionAmount ||
                        values?.approvedCourierDedictionAmount < 0)
                ) {
                    message.error("Kurye hakedişi için onaylanacak miktar gereklidir.");
                    return;
                }

                if (values.requestedAmount < 0) {
                    return;
                }
            }
            setConfirmLoading(true);
            try {
                if (values.status === "approved") {
                    const {note, companyProcessType, courierProcessType, ...rest} = values;
                    const approvedData = {
                        ...rest,
                        ...decisionData
                    };
                    try {
                        await stores.companyStore.approveObjection(approvedData);
                    } catch (error) {
                        console.error(error);
                    } finally {
                        setStatus("approved");
                        refetch();
                    }
                } else if (values.status === "rejected") {
                    const rejectedData = {
                        objectionId: values.objectionId,
                        note: values.note
                    };
                    try {
                        await stores.companyStore.rejectObjection(rejectedData);
                    } catch (error) {
                        console.error(error);
                    } finally {
                        setStatus("rejected");
                        refetch();
                    }
                }

                onCancel(true);
            } catch (error) {
                console.error("İtiraz durumu güncellenirken hata:", error);
            } finally {
                setConfirmLoading(false);
            }
        }
    });
    const {values, handleSubmit, handleChange, setFieldValue, setValues} = formik;

    return (
        <React.Fragment>
            <Modal
                title="İtiraz Onay Durumu"
                visible={visibility}
                onOk={handleSubmit}
                confirmLoading={confirmLoading}
                onCancel={onCancel}
                okText="Kaydet"
                cancelText="İptal"
                style={{top: 20}}
            >
                <>
                    <p>
                        <b>Alt Firma Adı</b> : {objection?.subCompany}
                    </p>
                    <p>
                        <b>Kullanıcı Adı</b> : {objection?.createdBy}
                    </p>
                    <p>
                        <b>Sipariş Numarası</b> :{" "}
                        {objection?.order?.vigoOrderNumber ? (
                            <Link
                                target="_blank"
                                data-testid="orderNumber"
                                style={{maxWidth: "470px"}}
                                to={{
                                    pathname: "/orders/" + objection?.deliveryId
                                }}
                            >
                                {objection?.order?.vigoOrderNumber}
                            </Link>
                        ) : (
                            <Link
                                target="_blank"
                                data-testid="orderNumber"
                                style={{maxWidth: "470px"}}
                                to={{pathname: "/orders/" + objection?.deliveryId}}
                            >
                                {objection?.order?.orderNumber}
                            </Link>
                        )}
                    </p>
                    <p>
                        <b>Sipariş Oluşturma Tarihi</b> :{" "}
                        {objection?.deliveryCreatedAt
                            ? moment(objection?.deliveryCreatedAt).format("DD/MM/YYYY")
                            : ""}
                    </p>
                    <p>
                        <b>İtiraz Oluşturma Tarihi</b> :{" "}
                        {objection?.createdAt
                            ? moment(objection?.createdAt).format("DD/MM/YYYY")
                            : ""}
                    </p>
                    <p>
                        <b>İtiraz Tipi</b> :{" "}
                        <Tag color="processing" style={{fontSize: "14px", fontWeight: "bold"}}>
                            {creditLogsObjectionTypes.find(obj => obj.value === objection?.type)
                                ?.label || "-"}
                        </Tag>
                    </p>
                    <p>
                        <b>İtiraz Nedeni</b> :{" "}
                        {(objection?.reason === "incorrectDistance" && "Mesafe İtirazı") ||
                            (objection?.reason === "incorrectDelivery" && "Teslimat İtirazı") ||
                            (objection?.reason === "other" && "Diğer") ||
                            (objection?.reason === "incorrectPayment" && "Ödeme itirazı")}
                    </p>
                    <p>
                        <b>İtiraz Tutarı</b> : {objection?.requestedAmount + "TL"}
                    </p>
                    <p>
                        <b>Açıklama</b> : {objection?.note}
                    </p>
                    <p>
                        <b>Belge</b> :{" "}
                        {objection?.files && objection?.files?.length > 0 ? (
                            <Button
                                size="small"
                                type="ghost"
                                onClick={() => handlePreviewFiles(objection?.files)}
                            >
                                Belgeleri Görüntüle
                            </Button>
                        ) : (
                            "Belge yok"
                        )}
                    </p>
                </>
                <Form layout="vertical">
                    <Form.Item label="Onay Durumu">
                        <Select
                            name="status"
                            value={values.status}
                            onChange={value => setStatus(value)}
                        >
                            <Select.Option value="approved">Onayla</Select.Option>
                            <Select.Option value="rejected">Reddet</Select.Option>
                        </Select>
                    </Form.Item>
                    {values.status === "approved" && (
                        <>
                            <Form.Item
                                label="Yapılacak İşlem (Firma)"
                                validateStatus={formik.errors.companyProcessType ? "error" : ""}
                                help={formik.errors.companyProcessType}
                            >
                                <Select
                                    name="companyProcessType"
                                    value={values.companyProcessType}
                                    onChange={value => setFieldValue("companyProcessType", value)}
                                >
                                    {creditLogObjectionApprovalTypesForCompany?.map(
                                        (type, index) => (
                                            <Select.Option key={type.value} value={type?.value}>
                                                {type?.label}
                                            </Select.Option>
                                        )
                                    )}
                                </Select>
                            </Form.Item>
                            <Form.Item label="Onaylanan İade Tutarı">
                                <InputNumber
                                    style={{width: "100%"}}
                                    name="approvedCompanyPaybackAmount"
                                    value={values.approvedCompanyPaybackAmount}
                                    onChange={value => {
                                        setFieldValue("approvedCompanyPaybackAmount", value);
                                    }}
                                    min="0"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Yapılacak İşlem (Kurye)"
                                validateStatus={formik.errors.courierProcessType ? "error" : ""}
                                help={formik.errors.courierProcessType}
                            >
                                <Select
                                    name="courierProcessType"
                                    value={values.courierProcessType}
                                    onChange={value => setFieldValue("courierProcessType", value)}
                                >
                                    {creditLogObjectionApprovalTypesForCourier?.map(
                                        (type, index) => (
                                            <Select.Option key={type.value} value={type?.value}>
                                                {type?.label}
                                            </Select.Option>
                                        )
                                    )}
                                </Select>
                            </Form.Item>
                            <Form.Item label="Onaylanan Kurye Kesintisi">
                                <InputNumber
                                    style={{width: "100%"}}
                                    name="approvedCourierDedictionAmount"
                                    type="number"
                                    value={values.approvedCourierDedictionAmount}
                                    onChange={value => {
                                        setFieldValue("approvedCourierDedictionAmount", value);
                                    }}
                                    min="0"
                                />
                            </Form.Item>
                        </>
                    )}

                    {values.status === "rejected" && (
                        <Form.Item label="Not">
                            <Input.TextArea
                                name="note"
                                placeholder="Reddetme nedeni..."
                                value={values.note}
                                onChange={handleChange}
                            />
                        </Form.Item>
                    )}
                </Form>
            </Modal>

            <Modal
                visible={fileModalVisible}
                footer={null}
                onCancel={() => setFileModalVisible(false)}
                width={800}
                title="Belgeleri Önizle"
            >
                <div style={{display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
                    {selectedFiles.map(file =>
                        file && file?.mimetype?.includes("pdf") ? (
                            <a
                                href={file.publicUrl}
                                target="_blank"
                                rel="noreferrer"
                                key={file._id}
                                style={{margin: 10}}
                            >
                                <Button type="primary">PDF Görüntüle</Button>
                            </a>
                        ) : (
                            file.publicUrl && (
                                <Image
                                    key={file._id}
                                    src={file.publicUrl}
                                    width={200}
                                    height={200}
                                    style={{objectFit: "contain", margin: 10}}
                                />
                            )
                        )
                    )}
                </div>
            </Modal>
        </React.Fragment>
    );
};
